export interface Page {
  id: string;
  name: string;
  caseId?: string;
  allowedRoles?: string[];
}
